import { render, staticRenderFns } from "./expanded-cravings.vue?vue&type=template&id=376f2c32&scoped=true&lang=pug&"
import script from "./expanded-cravings.vue?vue&type=script&lang=ts&"
export * from "./expanded-cravings.vue?vue&type=script&lang=ts&"
import style0 from "./expanded-cravings.vue?vue&type=style&index=0&id=376f2c32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376f2c32",
  null
  
)

export default component.exports